import { isValidPostCode } from '@/util/validators';

class FormAddress {
  city;
  state;
  country;
  lineOne;
  lineTwo;
  postCode;

  populate(data) {
    this.city = data.city || '';
    this.state = data.state || '';
    this.country = data.country || '';
    this.lineOne = data.lineOne || '';
    this.lineTwo = data.lineTwo || '';
    this.postCode = data.postCode || '';
  }

  get isPopulated() {
    return this.city !== '' && this.state !== '' && this.country !== '' && this.lineOne !== '' && this.postcode !== '';
  }

  isPostCodeValid() {
    return isValidPostCode(this.postCode);
  }

  doesValidate() {
    return this.isPostCodeValid();
  }

  constructor(data) {
    this.populate(data || {});
  }
}

export { FormAddress };
